export var SubscriptionStatus;
(function (SubscriptionStatus) {
    /* Stripe subscription status mapping:
    {
        "Stripe status": "Symon Status",
        "incomplete": "draft" and "draftTaxApplied",
        "incomplete_expired": "draftTaxApplied" (subscription gets purged after a while)
        "trialing": N/A (no trial),
        "active": "active",
        "past_due": "expired",
        "unpaid": "expired",
        "canceled": "cancelled"
    } */
    SubscriptionStatus["Draft"] = "draft";
    SubscriptionStatus["DraftTaxApplied"] = "draftTaxApplied";
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["Expired"] = "expired";
    SubscriptionStatus["Cancelled"] = "cancelled";
})(SubscriptionStatus || (SubscriptionStatus = {}));
//# sourceMappingURL=subscriptionStatus.js.map